module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_FISICA_3_B-59873fa14627126a6b64e13faf5df4b3.gif";